// src/services/crisp.service.js
import { Crisp } from "crisp-sdk-web";
import environment from "@/constants/Environment";

const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];
const environmentData: any = environment();
const OMNI_WEBSITE_ID = "92b6694a-fea8-4957-8b52-ec2f6fa49497";
const CBB_WEBSITE_ID = "d46c1117-1192-4647-bfe4-c3a2eea872a3";

const { isAI, ENVIRONMENT } = environmentData;
const isDevelopment = ENVIRONMENT === "development";

// 🔒 Add embed detection
const shouldLoadCrisp =
  !isAI &&
  !isDevelopment &&
  !window.location.pathname.endsWith("mu") &&
  !window.DISABLE_TRACKING &&
  !window.IS_EMBEDDED;

if (shouldLoadCrisp) {
  Crisp.configure(OMNI_WEBSITE_ID, {
    autoload: true,
    sessionMerge: true,
  });

  Crisp.session.setData(generateSessionData);
} else {
  console.log("Crisp disabled - embedded context");
}

function generateSessionData() {
  const sessionData = {};
  const searchParams = new URLSearchParams(window.location.search);

  for (const param of UTM_PARAMS) {
    if (searchParams.has(param)) {
      sessionData[param] = searchParams.get(param);
    }
  }

  return sessionData;
}
